var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title text-uppercase font-weight-bold"},[_vm._v("Configurações Aplicativo")]),_c('hr',{staticClass:"linha-amarela"}),_vm._l((_vm.configs),function(config,index){return _c('b-col',{key:index,staticClass:"mb-4",attrs:{"cols":"12"}},[_c('CardGpt',{attrs:{"nameConfig":config.nameConfig}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }